import React from "react";
import styles from "./Details.module.scss";

const Charts = (props) => {
  return (
    <div className={styles.main}>
      <div
        className={styles.informationContainer}
        style={{
          background: props.bgColor,
          color: props.color,
          padding: props.padding,
        }}
      >
        <p className={styles.label}>{props.label}</p>
        <p className={styles.value}>{props.value}</p>
      </div>
    </div>
  );
};

export default Charts;
